import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { person } from "../data/site";
import { Develop } from "./motion";

/** One word, inked in as the paragraph passes through its own scroll range. */
function Word({ children, progress, start, end }) {
  // Not lower than this: an un-inked word still has to be readable text, not a
  // ghost, for anyone who lands mid-paragraph or does not scroll at all.
  const opacity = useTransform(progress, [start, end], [0.38, 1]);
  return <motion.span style={{ opacity }}>{children} </motion.span>;
}

export default function Statement() {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const words = person.about.split(" ");

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 0.85", "end 0.55"],
  });

  return (
    <section className="section statement" ref={ref} id="statement">
      <div className="shell statement__inner">
        <figure className="statement__portrait">
          <Develop
            src={person.portrait}
            alt={person.portraitAlt}
            className="statement__portrait-img"
          />
          <figcaption className="label">The short version</figcaption>
        </figure>

        <p className="statement__text">
          {reduced
            ? person.about
            : words.map((word, i) => {
                const start = i / words.length;
                const end = start + 1 / words.length;
                return (
                  <Word key={`${word}-${i}`} progress={scrollYProgress} start={start} end={end}>
                    {word}
                  </Word>
                );
              })}
        </p>
      </div>
    </section>
  );
}
